// This is to be used with the Canada Post address lookup, please do not change without understanding how the API works

export enum FieldMode {
  COUNTRY = 8,
  DEFAULT = 3,
  NONE = 0,
  POPULATE = 2,
  PRESERVE = 4,
  SEARCH = 1
}

export interface Binding {
  element: string;
  field: string;
  mode: FieldMode;
}

export interface Options {
  key: string;
  name?: string;
  populate?: boolean;
  onlyInputs?: boolean;
  autoSearch?: boolean;
  preselect?: boolean;
  prompt?: boolean;
  promptDelay?: number;
  inlineMessages?: boolean;
  setCursor?: boolean;
  matchCount?: boolean;
  minSearch?: number;
  minItems?: number;
  maxItems?: number;
  manualEntry?: boolean;
  manualEntryItem?: boolean;
  disableTime?: number;
  suppressAutocomplete?: boolean;
  setCountryByIP?: boolean;
  culture?: string;
  languagePreference?: string;
  filteringMode?: unknown; // pca.filteringMode;
  orderingMode?: unknown; // pca.orderingMode;
  countries?: unknown; // pca.CountryList.Options;
  list?: unknown; // pca.AutoComplete.Options;
  bar?: unknown; // pca.Address.BarOptions;
  search?: unknown; // pca.Address.SearchOptions;
}
